export default __webpack_public_path__ + "static/media/sensotrend_uploader_login.450e9d21.png";